import { WEB_APPS_LIST_BY_NAME } from "../../modules/AppWrapper2/types.js";
//#region src/utils/URL-admin/make-admin-location-URL.ts
var ADMIN_LOCATION_PATH = `${WEB_APPS_LIST_BY_NAME.ADMIN.link}/locations/view/:locationId`;
function makeAdminLocationURL(locationId) {
	if (!locationId) console.warn("makeAdminLocationURL: no locationId provided");
	return ADMIN_LOCATION_PATH.replace(":locationId", locationId);
}
//#endregion
export { makeAdminLocationURL };

//# sourceMappingURL=make-admin-location-URL.js.map